import { render, staticRenderFns } from "./loadingPlaceholder.vue?vue&type=template&id=0ce9603e"
import script from "./loadingPlaceholder.vue?vue&type=script&lang=js"
export * from "./loadingPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./loadingPlaceholder.vue?vue&type=style&index=0&id=0ce9603e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports